<template>
  <transition name="fade">
    <router-view></router-view>
</transition>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      timer: null
    }
  },
  computed:{
    token() {
      return this.$store.state.common.token;
    }
  },
  created() {
    this.$store.commit("common/updateToken", sessionStorage.getItem("token"));
    if (this.token) {
      this.getMsgCount();
      this.setTimer();
      document.onkeydown=(event)=>{
        this.$bus.$emit('onkeydown',event);
      }
    }
  },
  mounted() {

  },
  methods:{
    getMsgCount() {
      this.$ajax.get(this.$api.notice.count,{},{noLoading:true}).then(res => {
        this.$store.commit("common/updateNoticeCount", res.data);
      });
    },
    setTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.getMsgCount();
      }, 5000);
    }
  },
  watch:{
    token:{
      handler(newVal) {
        if(newVal){
          this.setTimer();
        }
      },
      immediate: true
    }
  }
}
</script>
